import type { ViewState } from '../app/viewState';

interface AppHeaderProps {
  view: ViewState;
  onBack: () => void;
}

const TITLES: Record<ViewState['kind'], string> = {
  home: 'Your inspections',
  'new-property': 'New property',
  property: 'Property',
  walkthrough: 'Walkthrough',
  report: 'Report',
  'sign-up': 'Save inspection',
};

export function AppHeader({ view, onBack }: AppHeaderProps) {
  const showBack = view.kind !== 'home';
  return (
    <header className="appbar" role="banner">
      {showBack ? (
        <button
          type="button"
          className="appbar-back"
          onClick={onBack}
          aria-label="Back"
        >
          ← Back
        </button>
      ) : (
        <span className="appbar-brand">
          Prop<span className="appbar-brand-accent">Defect</span>
        </span>
      )}
      <span className="appbar-title">{TITLES[view.kind]}</span>
      <span className="appbar-spacer" aria-hidden="true" />
    </header>
  );
}
